import * as React from 'react';
import { connect } from 'react-redux';
import UtilityService from '../../services/UtilityService';
import SignalRService from '../../signalRController';

class RebuildShortCodes extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            message: ""
        };

        this.triggerRebuild = this.triggerRebuild.bind(this);
    }

    private emptyState() {
        return {
            message: ""
        };
    }

    triggerRebuild = async () => {
        this.setState({ message: "Short Codes rebuild triggered!" });
        await UtilityService.rebuildShortCodes();
    }

    componentDidMount = () => {
        SignalRService.registerReceiveEvent("RebuildShortCodes",
            (msg) => {
                this.setState({ message: msg.Message });
            }
        );
    }

    componentWillUnmount() {
        SignalRService.unRegisterReceiveEvent("RebuildShortCodes");
    }

    public render() {
        const { message } = this.state;
        return (
            <React.Fragment>
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12">
                            <button className="btn" onClick={this.triggerRebuild}>Rebuild Short Codes</button> {message}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
};

export default connect()(RebuildShortCodes);
